import React, { Component } from "react";

interface IBetHistoryComponent {
    data: {}
}
export const betHistoryComponent: IBetHistoryComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "name": "backgroundGraphic",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": true,
                        "alpha": 1,
                        "color": "0x242424",
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 1080,
                    },

                    {
                        "name": "backgroundGraphic",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": true,
                        "alpha": 1,
                        "color": "0x131313",
                        "x": 148,
                        "y": 256,
                        "width": 1623,
                        "height": 662,

                    },
                    {
                        "id": "Bet_History_Heading",
                        "name": "Bet_History_Heading",
                        "type": "Text",
                        "x": 856,
                        "y": 80,
                        "width": 300,
                        "visible": true,
                        "text": "menu-title_bet-history",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Oswald-Regular',
                            fontSize: 50,
                            fontStyle: 'normal',
                            fill: ['#ffffff'],
                        },
                    },
                    {
                        "id": "betHistoryScrollComponent",
                        "name": "betHistoryScrollComponent",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [
                           
                        ]
                    },
                    {
                        "id": "betHistoryContent",
                        "name": "betHistoryContent",
                        "type": "Container",
                        "x": 100,
                        "y": -100,
                        "visible": true,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "Bet_History_Heading",
                                "name": "Bet_History_Heading",
                                "type": "Text",
                                "x": 870,
                                "y": 420,
                                "width": 300,
                                "visible": true,
                                "text": "bet-history_no-bets",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-Regular',
                                    fontSize: 32,
                                    fontStyle: 'normal',
                                    fill: ['#ffffff'],
                                },
                            },
                        ]
                    },
                ]
            },

        ],
    }


};

export const BetHistoryComponentConfigurationContext = React.createContext(
    {}
);